import { createSelector } from 'reselect';
import { AppState } from '../createStore';

const sessionSelector = (state: AppState) => state.session;

export const selectOrderPacingLevel = createSelector([sessionSelector], (session: any) => {
  return session?.orderPacing?.level;
});
